import { useEffect } from 'react';
import { useQueryClient } from 'react-query';
import { Channels } from '../utils/channels';
import { invalidateDashboardQueries } from '../utils/invalidateDashboardQueries';
import { queryKeys } from './queryKeyFactory';
import { invalidateFeedQueries } from '../utils/invalidateFeedQueries';

export default (): void => {
  const queryClient = useQueryClient();

  useEffect(() => {
    Channels.initialize();

    subscribeToMessages();

    return () => Channels.close();
  }, []);

  const subscribeToMessages = () => {
    Channels.likeChannel.onmessage = () => {
      queryClient.invalidateQueries([queryKeys.fetchLikes.all]);
    };

    Channels.readingListChannel.onmessage = () => {
      queryClient.invalidateQueries([queryKeys.fetchReadingLists.all]);
    };

    Channels.recentlyViewedChannel.onmessage = () => {
      queryClient.invalidateQueries([queryKeys.fetchRecentlyViewed.all]);
    };

    Channels.watchlistsChannel.onmessage = (id: string) => {
      queryClient.invalidateQueries([queryKeys.fetchWatchlists.all]);
      invalidateFeedQueries(queryClient);
      queryClient.invalidateQueries(queryKeys.fetchIssuers.query({ watchlistId: id }));
      invalidateDashboardQueries(queryClient, id);
    };

    Channels.preferencesChannel.onmessage = () => {
      queryClient.invalidateQueries([queryKeys.fetchMyContentPreferences]);
      invalidateFeedQueries(queryClient);
    };

    Channels.savedSearchesChannel.onmessage = () => {
      queryClient.invalidateQueries([queryKeys.fetchSavedSearches.all]);
    };

    Channels.docketDocumentsChannel.onmessage = () => {
      queryClient.invalidateQueries([queryKeys.dockets.fetchDocuments.all]);
    };
  };
};
